import { render, staticRenderFns } from "./TurnedTextStyleEditor.vue?vue&type=template&id=553eff92&"
import script from "./TurnedTextStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./TurnedTextStyleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports